// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;

import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41')
];

export const server_loads = [];

export const dictionary = {
		"/": [~2],
		"/about": [32],
		"/all": [~33],
		"/all/[collectionSlug]/[[page]]": [~34],
		"/atlas": [~35],
		"/cities": [~36],
		"/cities/random": [~37],
		"/countries": [~38],
		"/privacy-policy": [39],
		"/search": [~40],
		"/terms-of-use": [41],
		"/[countrySlug]": [~3],
		"/[countrySlug]/[collectionSlug=collection]": [~31],
		"/[countrySlug]/[citySlug]": [~4],
		"/[countrySlug]/[citySlug]/activities": [~5],
		"/[countrySlug]/[citySlug]/architecture": [~6],
		"/[countrySlug]/[citySlug]/attractions": [~7],
		"/[countrySlug]/[citySlug]/attractions/[featureSlug]": [~8],
		"/[countrySlug]/[citySlug]/cycling-routes": [~9],
		"/[countrySlug]/[citySlug]/cycling-routes/[featureSlug]": [~10],
		"/[countrySlug]/[citySlug]/festivals": [~11],
		"/[countrySlug]/[citySlug]/foods": [~12],
		"/[countrySlug]/[citySlug]/free-things-to-do": [~13],
		"/[countrySlug]/[citySlug]/hidden-gems": [~14],
		"/[countrySlug]/[citySlug]/highlights": [~15],
		"/[countrySlug]/[citySlug]/itineraries": [~16],
		"/[countrySlug]/[citySlug]/itineraries/[featureSlug]": [~17],
		"/[countrySlug]/[citySlug]/markets-and-shopping": [~18],
		"/[countrySlug]/[citySlug]/nightlife": [~19],
		"/[countrySlug]/[citySlug]/parks-and-nature": [~20],
		"/[countrySlug]/[citySlug]/parks-and-nature/[featureSlug]": [~21],
		"/[countrySlug]/[citySlug]/photo-spots": [~22],
		"/[countrySlug]/[citySlug]/seasons": [~23],
		"/[countrySlug]/[citySlug]/self-guided-tours": [~24],
		"/[countrySlug]/[citySlug]/self-guided-tours/[featureSlug]": [~25],
		"/[countrySlug]/[citySlug]/unesco-heritage-sites": [~26],
		"/[countrySlug]/[citySlug]/unesco-heritage-sites/[featureSlug]": [~27],
		"/[countrySlug]/[citySlug]/viewpoints": [~28],
		"/[countrySlug]/[citySlug]/walking-routes": [~29],
		"/[countrySlug]/[citySlug]/walking-routes/[featureSlug]": [~30]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);